import React from "react";
import { Link } from "react-router-dom";
import { Car, ArrowLeft, Phone, Mail, MessageCircle } from "lucide-react";
import LocationSection from "@/components/LocationSection";

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="contact-page">
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <Link to="/" className="p-2 hover:bg-gray-100 rounded-lg" data-testid="contact-back">
                <ArrowLeft className="w-5 h-5 text-gray-600" />
              </Link>
              <Link to="/" className="flex items-center gap-2">
                <div className="w-8 h-8 bg-emerald-500 rounded-lg flex items-center justify-center">
                  <Car className="w-5 h-5 text-white" />
                </div>
                <span className="font-bold text-gray-900">AutoPro Daune</span>
              </Link>
            </div>
            <a href="tel:+40725399235" className="flex items-center gap-1.5 text-emerald-600 font-medium">
              <Phone className="w-4 h-4" />
              <span className="hidden sm:inline">0725 399 235</span>
            </a>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Contact</h1>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">Vino la centrul nostru de constatare sau contacteaza-ne prin telefon, email sau WhatsApp.</p>
        </div>

        {/* Contact methods */}
        <div className="grid sm:grid-cols-3 gap-4 mb-12 max-w-3xl mx-auto">
          <a href="tel:+40725399235" className="flex flex-col items-center gap-3 p-6 bg-gray-50 rounded-2xl hover:bg-emerald-50 transition-colors group" data-testid="contact-phone">
            <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center group-hover:bg-emerald-200 transition-colors">
              <Phone className="w-7 h-7 text-emerald-600" />
            </div>
            <div className="text-center">
              <p className="font-bold text-gray-900">Telefon</p>
              <p className="text-emerald-600 font-medium">0725 399 235</p>
            </div>
          </a>
          <a href="https://wa.me/40725399235" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-3 p-6 bg-gray-50 rounded-2xl hover:bg-emerald-50 transition-colors group" data-testid="contact-whatsapp">
            <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center group-hover:bg-emerald-200 transition-colors">
              <MessageCircle className="w-7 h-7 text-emerald-600" />
            </div>
            <div className="text-center">
              <p className="font-bold text-gray-900">WhatsApp</p>
              <p className="text-emerald-600 font-medium">Raspundem rapid</p>
            </div>
          </a>
          <a href="mailto:office@autoprodaune.ro" className="flex flex-col items-center gap-3 p-6 bg-gray-50 rounded-2xl hover:bg-emerald-50 transition-colors group" data-testid="contact-email">
            <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center group-hover:bg-emerald-200 transition-colors">
              <Mail className="w-7 h-7 text-emerald-600" />
            </div>
            <div className="text-center">
              <p className="font-bold text-gray-900">Email</p>
              <p className="text-emerald-600 font-medium">office@autoprodaune.ro</p>
            </div>
          </a>
        </div>

        {/* Location Section */}
        <LocationSection variant="page" />
      </main>
    </div>
  );
};

export default ContactPage;
